var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "close-test",
    opacity: 0.2,
    d: "M12.3353 10.4161L20.2902 18.3711L18.1689 20.4924L10.214 12.5374L2.25902 20.4924L0.137695 18.3711L8.09265 10.4161L0.137695 2.46116L2.25902 0.339845L10.214 8.2948L18.1689 0.339844L20.2902 2.46116L12.3353 10.4161Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.b132fddec484399aee61433829b95d38.svg";
export { ForwardRef as ReactComponent };